import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import DisplayReportContent from '../../Report/DisplayReport';

const DisplayReport = (): JSX.Element => {
    
  const theme = useTheme();

  const queryParams = new URLSearchParams(window.location.search)
  const [reportId, setReportId] = useState(0);
  const [isIE, setIsIE] = useState(false);

  useEffect(() => {
    const reportId = queryParams.get("id");
    const isIE = queryParams.get("isIE");
    setReportId(parseInt(reportId || "0"));
    setIsIE(isIE ? true : false);
  }, [])

  return (
    <Main>
      <Container>
       <DisplayReportContent reportId={reportId} isIE={isIE}></DisplayReportContent>
      </Container>
    </Main>
  );
};

export default DisplayReport;